import axiosInstance from '@/services/axiosInstance'

async function updatecertificadotiposerial (payload = {}) {
  if (process.env.VUE_APP_ENVIRONMENT === 'testss') {
    return new Promise((resolve, reject) => {
      resolve()
    })
  } else {
    const req = {
      url: 'api/certificados/updatecertificadotiposerial',
      method: 'PUT',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data: payload
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { updatecertificadotiposerial }
